import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {SpecificationQuestion} from "../_models/SpecificationQuestion";
import {SpecificationQuestionsRequestIds} from "../_models/SpecificationQuestionsRequestIds";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class SpecificationQuestionsService {
  constructor(private httpClient: HttpClient, private oauthService: OAuthService) {
  }

  getSpecificationQuestions(request: SpecificationQuestionsRequestIds) {
    return this.httpClient.post<SpecificationQuestion[]>('/api/specificationquestions/getselectedspecificationquestions', request);
  }
}
